import { Autocomplete, Box, CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, ListSubheader, MenuItem, Select, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useMemo, useRef, useState } from "react";
import { debounce } from "lodash";
import usePort from "../hooks/usePort";

const PortsDropdown = (props) => {
    const {onChange} = props

    const [portOptions, setPortOptions] = useState([]);
    const [currentPort, setCurrentPort] = useState(null);
    const [inputSearchValue, setInputSearchValue] = useState('');
    const [open, setOpen] = useState(false);

    const {
        isListingPort,
        portListWithPaginationV2,
        getListPortWithPagination,

        isSearchingPort,
        searchedPort,
        searchPort,
    } = usePort()

    useEffect(() => {
        handleGetPortList()
    }, [])

    useEffect(() => {
        if (portListWithPaginationV2) {
            setPortOptions(portListWithPaginationV2?.content)
        }
    }, [JSON.stringify(portListWithPaginationV2)])

    useEffect(() => {
        if (searchedPort) {
            setPortOptions(searchedPort?.data)
        }
    },[JSON.stringify(searchedPort)])

    const debouncedSearch = useMemo(
    () =>
        debounce(async (searchText) => {
            if (!searchText) {
                handleGetPortList()
                return;
            }
            searchPort(searchText)
        }, 800),
        []
    );

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    const handleGetPortList = () => {
        let query_params = {
            page: 1,
            limit: 10
        }
        getListPortWithPagination(query_params)
    }

    const handleInputChange = (event, value, reason) => {
        setInputSearchValue(value);
        // if (reason === 'input') {
        //     const hasMatch = portOptions.some((opt) => opt?.port_name.toLowerCase().includes(value.toLowerCase()));
        //     if (!hasMatch) {
        //         debouncedSearch(value);
        //     }
        // }
    };

    const handleClose = () => {
        setOpen(false);
        handleGetPortList()
    };

    const handleClear = () => {
        setInputSearchValue('');
        onChange('')
        setCurrentPort(null)
        handleGetPortList()
    };

    const handleOnSelect = (e, value) => {
        if (value) {
            setCurrentPort(value)
            onChange(value)
        }
    }

    const handleOnEnter = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent form submission or default behavior
            console.log('Enter pressed with input:', inputSearchValue);

            // call api search
            if (inputSearchValue) {
                searchPort(inputSearchValue)
            }
        }
    }

    return (
        <Autocomplete
            {...props}
            fullWidth
            size="small"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={handleClose}
            options={portOptions}
            getOptionLabel={(option) => option.port_name}
            value={currentPort}
            inputValue={inputSearchValue}
            onInputChange={handleInputChange}
            onChange={handleOnSelect}
            loading={isListingPort || isSearchingPort}
            clearIcon={false}
            renderInput={(params) => (
                <TextField
                {...params}
                label="Select Port"
                onKeyDown={handleOnEnter}
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                    <>
                        {inputSearchValue && (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClear} edge="end" size="small">
                                <CloseIcon />
                            </IconButton>
                        </InputAdornment>
                        )}
                        {isListingPort || isSearchingPort && <CircularProgress size={20} sx={{ ml: 1 }} />}
                        {params.InputProps.endAdornment}
                    </>
                    )
                }}
                />
            )}
        />
    );
}

export default PortsDropdown